export const creatOrderThird = [
  {
    path: `/CreatOrderThird`,
    name: `CreatOrderThird`,
    redirect: `/creatOrderThird/third`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/creatOrderThird/third',
        name: 'CreatOrderThird/third',
        component: () => import('@/views/creatorderthird/CreatOrderThird')
      }
    ]
  }
];
